import { fetchApi } from '@/config/axiosSetting';

import {
  GetBodyCostsQueryResponseType,
  IBodyGetCostsQueryParams,
} from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyCosts/getBodyCostsQuery.type';

export const getBodyCostsQueryFunction = (
  params: IBodyGetCostsQueryParams,
): Promise<GetBodyCostsQueryResponseType> => {
  return fetchApi.get(
    `body/reports/${params?.id}/accident_users/damaged/adjusting/costs/`,
    { params },
  );
};
